import React from "react";
import Image from "next/image";
import SectionTitle from "../../Common/SectionTitle";

const checkIcon = (
  <svg width="16" height="13" viewBox="0 0 16 13" className="fill-current">
    <path d="M5.8535 12.6631C5.65824 12.8584 5.34166 12.8584 5.1464 12.6631L0.678505 8.1952C0.483242 7.99994 0.483242 7.68336 0.678505 7.4881L2.32921 5.83739C2.52467 5.64193 2.84166 5.64216 3.03684 5.83791L5.14622 7.95354C5.34147 8.14936 5.65859 8.14952 5.85403 7.95388L13.3797 0.420561C13.575 0.22513 13.8917 0.225051 14.087 0.420383L15.7381 2.07143C15.9333 2.26669 15.9333 2.58327 15.7381 2.77854L5.8535 12.6631Z" />
  </svg>
);

interface ListProps {
  text: string;
}

interface AboutSectionOneMobileProps {
  title: string;
  paragraph: string;
  list1: string;
  list2: string;
  list3: string;
  list4: string;
}

const List = ({ text }: ListProps) => (
  <p className="mb-3 flex items-center text-base font-medium text-body-color">
    <span className="mr-3 flex h-[25px] w-[25px] items-center justify-center rounded-md bg-primary bg-opacity-10 text-primary">
      {checkIcon}
    </span>
    {text}
  </p>
);

const AboutSectionOneMobile = ({
  title,
  paragraph,
  list1,
  list2,
  list3,
  list4
}: AboutSectionOneMobileProps) => {



  return (
    <div className="container">
      <div className="border-b border-body-color/[.15] pb-10 dark:border-white/[.15]">
        <div className="-mx-4 flex flex-wrap">
          {/* Image first on mobile */}
          <div className="w-full px-4 mb-8">
            <div className="relative mx-auto aspect-[25/24] max-w-[350px]">
              <Image
                src="/images/about/about-image.png"
                alt="about-image"
                fill
                className="mx-auto max-w-full drop-shadow-three dark:hidden dark:drop-shadow-none"
              />
              <Image
                src="/images/about/about-image-dark.png"
                alt="about-image"
                fill
                className="mx-auto hidden max-w-full drop-shadow-three dark:block dark:drop-shadow-none"
              />
            </div>
          </div>
          
          {/* Content after image on mobile */}
          <div className="w-full px-4">
            <SectionTitle
              title={title} 
              paragraph={paragraph} 
              mb="30px"
            />

            <div
              className="mb-10 max-w-full"
              data-wow-delay=".15s"
            >
              <div className="mx-[-12px]">
                <div className="w-full px-3">
                  <List text={list1} /> 
                  <List text={list2} /> 
                  <List text={list3} /> 
                  <List text={list4} /> 
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutSectionOneMobile; 